







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ContentImage extends Vue {
	@Prop({ required: true })block!: any
}
